import { TableCellProps, TableCell } from '@mui/material';
import { styled } from '@mui/material/styles';

export const TableCellStyled = styled(TableCell)<TableCellProps>(
  ({ theme }) => ({
    '&.MuiTableCell-root': {
      borderColor: theme.palette.border?.tertiary,
    },
  })
);
